module.exports = __webpack_public_path__ + "static/13_LENDER_TELEPHONY_MANAGER-A_MAYALA-365c130596785f6a4d34fc20bef5eb57.png";